export default __webpack_public_path__ + "static/media/star.943ff46b.svg";